@if (label) {
  <label>{{ label | transloco }}</label>
}
<nz-checkbox-group
  [(ngModel)]="checkboxGroupOptions"
  [nzDisabled]="disabled"
  (blur)="syncExternalTouched()"
  (ngModelChange)="onModelChange($event)">
</nz-checkbox-group>
